import { render, staticRenderFns } from "./TopProductsCard.vue?vue&type=template&id=036ebd97&scoped=true"
import script from "./TopProductsCard.vue?vue&type=script&lang=ts"
export * from "./TopProductsCard.vue?vue&type=script&lang=ts"
import style0 from "./TopProductsCard.vue?vue&type=style&index=0&id=036ebd97&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "036ebd97",
  null
  
)

export default component.exports